import React, { useEffect, useState } from 'react';
import { candidateAPI } from '../services/api';

// Shows one of a candidate's uploaded documents (ID, qualification, CPD record)
// inside a modal.
//
// The file is always fetched through the backend — which applies the app's role
// check — and shown from a blob URL, with the session in the Authorization
// header, never in the URL. Drive's own previewer (an iframe of
// drive.google.com/file/d/<id>/preview) used to be embedded for all-access roles,
// but browsers now block Google's cookies inside a frame on another site, so it
// showed "Sign in to your Google Account" instead of the document (Sophie's ID,
// 2026-10-04). The backend route has no such dependency. `direct` (all-access
// role) now only adds an "Open in Drive" link, for anything the browser cannot
// render inline.
function CandidateDocumentFrame({ candidateId, kind, fileId, direct, title }) {
  const [blob, setBlob] = useState(null);   // { url, type }
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    let objectUrl = null;
    setBlob(null);
    setError('');
    candidateAPI.fetchDocumentFile(candidateId, kind)
      .then((data) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(data);
        setBlob({ url: objectUrl, type: data.type || '' });
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.response?.status === 403
          ? 'You do not have access to this document.'
          : 'This document could not be loaded. Please try again.');
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [candidateId, kind, fileId]);

  const frameStyle = { width: '100%', height: '100%', border: 'none', backgroundColor: 'white' };
  const messageStyle = { padding: '40px', textAlign: 'center', color: 'var(--color-text-muted)' };

  const driveLink = direct && (
    <div style={{ padding: '8px 12px', textAlign: 'right', fontSize: '13px' }}>
      <a href={`https://drive.google.com/file/d/${fileId}/view`} target="_blank" rel="noopener noreferrer">
        Open in Drive
      </a>
    </div>
  );

  if (error) return <div style={messageStyle}>{error}{driveLink}</div>;
  if (!blob) return <div style={messageStyle}>Loading document…</div>;
  if (blob.type.startsWith('image/')) {
    return (
      <div style={{ width: '100%', height: '100%', overflow: 'auto', backgroundColor: 'white', textAlign: 'center' }}>
        <img src={blob.url} alt={title} style={{ maxWidth: '100%' }} />
      </div>
    );
  }
  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
      <iframe src={blob.url} style={{ ...frameStyle, flex: 1 }} title={title} />
      {driveLink}
    </div>
  );
}

export default CandidateDocumentFrame;
